<template>
  <div class="rc">
    <div class="right-bg"></div>
    <img src="../../assets/login-register-logo.svg" class="right-logo" alt="" />
    <div class="list-of-goods">
      <ul style="list-style: none">
        <li>
          <img src="../../assets/list-mark-option.svg" alt=""/>
          Safest platform for investing in loans
        </li>
        <li>
          <img src="../../assets/list-line-option.svg" alt=""/>
          Earn from 7–15% annually
        </li>
        <li>
          <img src="../../assets/list-bank-option.svg" alt=""/>
          No fees, start with 10 euro
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightColumn'
}
</script>

<style scoped lang="scss">

.rc {
  width: 100%;
  height: 100vh;
}
.right-bg {
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/media/login-right-bg.png");
  filter: brightness(50%);
}
.right-logo {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}

.list-of-goods{
  color: #FFFFFF;
  font-weight: bold;
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50%, -50%);
  font-size: 18px;
}

@media only screen and (max-width: 2000px) {
  .list-of-goods{
    width: 68%;
  }
}

@media only screen and (max-width: 1487px) {
  .list-of-goods{
    width: 89%;
  }
}

@media (max-height: 800px) {
  .right-logo {
    left: 50%;
    top: 33%;
  }
}
</style>
